import { Navigate, Outlet } from 'react-router-dom'
import useAutoShowToastWhenSessionExpired from '../../hooks/useAutoShowToastWhenSessionExpired'
import { useLocation } from 'react-router-dom'
import { NotificationClickHandler } from '@/modules/notification/components/NotificationClickHandler'
import { useQueryCheckOverdueInvoices } from '@/modules/crypto-invoices/api/hooks/useQueryCheckOverdueInvoices'
import { OverdueInvoiceWarningModal } from '@/modules/crypto-invoices/components/OverdueInvoiceWarningModal'
export default function RootPage() {
	useAutoShowToastWhenSessionExpired()

	const { pathname } = useLocation()
	const { data: overdueData } = useQueryCheckOverdueInvoices()

	if (
		(!localStorage.getItem('token') || !localStorage.getItem('role')) &&
		pathname !== '/login'
	) {
		return <Navigate to={`/login?path=${encodeURIComponent(pathname)}`} />
	}

	if (localStorage.getItem('role') === 'ADMIN' && pathname === '/') {
		return <Navigate to="/admin" />
	}

	if (localStorage.getItem('role') === 'OPERATOR' && pathname === '/') {
		return <Navigate to="/operator" />
	}

	return (
		<>
			<NotificationClickHandler />
			{overdueData && <OverdueInvoiceWarningModal data={overdueData} />}
			<Outlet />
		</>
	)
}
